import { Type } from 'class-transformer';
import { AddContactInfoCustomFieldRawDto } from './add-contact-info-custom-field-raw-dto';

export class AddContactInfoRawDto {
  contactDetailId: number;
  contactId: number;
  contactTypeId: number;
  content: string;
  description: string;
  sequence: number;
  subTypeId: string;

  @Type(() => AddContactInfoCustomFieldRawDto)
  customFieldsData: Array<AddContactInfoCustomFieldRawDto>;

  crudAction: string;
  confirmedReceiveText: boolean;
}
